import React from 'react';
import PropTypes from 'prop-types';

const LogoHeader = () => {
  return (
    <header className="bg-white shadow-sm border-b">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-white-600 rounded-lg flex items-center justify-center">
              {/* <span className="text-white font-bold text-lg">EH</span> */}
              <img src="https://theexamhub.com/assets/images/logolatest.png" alt="TheExamHub" className="w-12 h-12" />

            </div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">The Exam HUB</h1>
              <p className="text-sm text-gray-600">Secure Online Examination Platform</p>
            </div>
          </div>
          
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-gray-200 rounded-lg flex items-center justify-center">
              <span className="text-gray-600 font-bold text-sm">SSC</span>
            </div>
            <div className="text-right">
              <h2 className="text-lg font-semibold text-gray-900">SSC Exam</h2>
              <p className="text-sm text-gray-600">Government Examination</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

LogoHeader.propTypes = {
  // Add any props if needed in the future
};

export default LogoHeader; 